(function () {
  'use strict';

  function initCalendar(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cal-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cal-panel]'));
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-cal-filter]'));
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 12;
    var state = { country: root.getAttribute('data-default') || 'NL', filter: 'all', expanded: false };

    function render() {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-cal-tab') === state.country;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      filters.forEach(function (f) {
        f.setAttribute('aria-pressed', f.getAttribute('data-cal-filter') === state.filter ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-cal-panel') === state.country;
        p.hidden = !on;
        if (!on) return;
        var shown = 0;
        var items = p.querySelectorAll('[data-ev]');
        Array.prototype.forEach.call(items, function (it) {
          var groups = it.getAttribute('data-group');
          var match = state.filter === 'all' || groups === state.filter;
          var visible = match && (state.expanded || shown < limit);
          if (match && visible) shown++;
          it.hidden = !visible;
          it.setAttribute('data-match', match ? '1' : '0');
        });
        var total = p.querySelectorAll('[data-ev][data-match="1"]').length;
        Array.prototype.forEach.call(p.querySelectorAll('[data-month]'), function (m) {
          var list = m.nextElementSibling;
          var any = list && list.querySelector('[data-ev]:not([hidden])');
          m.hidden = !any;
          if (list) list.hidden = !any;
        });
        var more = p.querySelector('[data-cal-more]');
        if (more) more.hidden = state.expanded || total <= limit;
        var empty = p.querySelector('[data-cal-empty]');
        if (empty) empty.hidden = total > 0;
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        state.country = t.getAttribute('data-cal-tab');
        state.expanded = false;
        render();
        if (history.replaceState) history.replaceState(null, '', '#' + t.getAttribute('data-hash'));
      });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        n.focus();
        n.click();
      });
    });
    filters.forEach(function (f) {
      f.addEventListener('click', function () {
        state.filter = f.getAttribute('data-cal-filter');
        state.expanded = false;
        render();
      });
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cal-more]')) {
        state.expanded = true;
        render();
      }
    });

    var hash = (location.hash || '').replace('#', '');
    tabs.forEach(function (t) {
      if (hash && t.getAttribute('data-hash') === hash) {
        state.country = t.getAttribute('data-cal-tab');
        setTimeout(function () { root.scrollIntoView({ block: 'start' }); }, 50);
      }
    });
    render();
  }

  function initArticle(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.hdxj-prose table'), function (t) {
      if (t.parentElement.classList.contains('hdxj-tablewrap')) return;
      var w = document.createElement('div');
      w.className = 'hdxj-tablewrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
    Array.prototype.forEach.call(root.querySelectorAll('.hdxj-prose a[href^="http"]'), function (a) {
      if (a.hostname !== location.hostname) {
        a.target = '_blank';
        a.rel = 'noopener';
      }
    });
    var copy = root.querySelector('[data-copy-link]');
    if (copy) {
      copy.addEventListener('click', function () {
        var done = function () {
          var label = copy.textContent;
          copy.textContent = copy.getAttribute('data-copied');
          setTimeout(function () { copy.textContent = label; }, 1800);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(location.href.split('#')[0]).then(done, done);
      });
    }
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-hdxj-calendar]'), initCalendar);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-hdxj-article]'), initArticle);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
